import { queryClient } from '@/utils/queryClient'

import { getFeatureFlagKeys } from './apis'
import { FEATURE_FLAG_STALE_TIME } from './consts'
import { featureFlagQueryKeys } from './useFeatureQueries'

/**
 * 1.0 공통 API(화면 비종속) → 2.0 전환 flag (LOGISPRD-14500).
 * object flag 의 필드 하나 = API(또는 한 흐름) 하나. 필드명 = 1.0 경로 camelCase. BE(V2CommonApiFeatureFlag)와 같은 필드를 읽는다.
 * 기본 false = 1.0, 조회 실패 = [] = 1.0 (fail-safe). 1.0 종료 전에 필드별로 분기 코드를 제거해야 한다 — 1.0 이 꺼진 뒤의 조회 실패는 장애다.
 */
export const V2_COMMON_API_FLAG = 'feature.v2CommonApi'

export type V2CommonApiField = 'authCheck' | 'authMenu'

// getFeatureFlagKeys 가 실패를 [] 로 바꾸므로 queryFn 이 throw 하지 않는다 — queryCache onError 알럿이 뜨지 않는다.
// 대신 실패 결과 [] 도 staleTime 동안 캐시된다(그동안 모든 필드 OFF).
// config 는 queryKey 에 없다 — 같은 조회가 진행 중이면 나중 호출의 config 는 쓰이지 않는다.
export const isV2CommonApiOn = async (field: V2CommonApiField, config?: Parameters<typeof getFeatureFlagKeys>[1]): Promise<boolean> => {
  const keys = await queryClient.fetchQuery({
    queryKey: featureFlagQueryKeys.keys(V2_COMMON_API_FLAG),
    queryFn: () => getFeatureFlagKeys(V2_COMMON_API_FLAG, config),
    staleTime: FEATURE_FLAG_STALE_TIME,
  })
  return keys.includes(field)
}
